// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfficeDetailBlock_root__oNjx6 {
  padding-top: 40px;
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 95px);
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx {
  display: flex;
  flex-grow: 1;
  padding-top: 40px;
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_block__OmOH1 {
  display: flex;
  flex-grow: 1;
  width: 100%;
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_left__h33Oq {
  width: 50%;
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_left__h33Oq img {
  display: none;
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd {
  width: 50%;
  padding: 40px;
  background: rgba(223, 223, 223, 0.5019607843);
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_titleBlock__1ugxg {
  font-size: 26px;
  font-weight: bold;
  color: #d71921;
}
.OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_infoBlock__Tcpk5 {
  color: #00377c;
}

@media (max-width: 768px) {
  .OfficeDetailBlock_root__oNjx6 {
    padding-top: 20px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak {
    min-height: calc(100vh - 65px);
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx {
    padding-top: 20px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd {
    padding: 20px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_titleBlock__1ugxg {
    font-size: 18px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_imageBlock__9JOPx img {
    height: 120px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_infoBlock__Tcpk5 {
    font-size: 14px;
  }
}
@media (max-width: 500px) {
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak {
    min-height: calc(100vh - 61px);
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx {
    flex-direction: column;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_block__OmOH1 {
    justify-content: center;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_left__h33Oq {
    width: 100%;
    height: 100px;
    background: none;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_left__h33Oq img {
    display: block;
    width: 100%;
    object-fit: cover;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd {
    width: 100%;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_titleBlock__1ugxg {
    font-size: 16px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_imageBlock__9JOPx img {
    height: 80px;
  }
  .OfficeDetailBlock_root__oNjx6 .OfficeDetailBlock_container__4WEak .OfficeDetailBlock_wrapper__-5Eyx .OfficeDetailBlock_right__BIbpd .OfficeDetailBlock_infoBlock__Tcpk5 {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OfficeDetailBlock/OfficeDetailBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACJ;AACI;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AACN;AACM;EACE,aAAA;EACA,YAAA;EACA,WAAA;AACR;AAEM;EACE,UAAA;AAAR;AAEQ;EACE,aAAA;AAAV;AAIM;EACE,UAAA;EACA,aAAA;EACA,6CAAA;AAFR;AAIQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAFV;AAKQ;EACE,cAAA;AAHV;;AAUA;EACE;IACE,iBAAA;EAPF;EASE;IACE,8BAAA;EAPJ;EASI;IACE,iBAAA;EAPN;EASM;IACE,aAAA;EAPR;EASQ;IACE,eAAA;EAPV;EAWU;IACE,aAAA;EATZ;EAaQ;IACE,eAAA;EAXV;AACF;AAkBA;EAEI;IACE,8BAAA;EAjBJ;EAmBI;IACE,sBAAA;EAjBN;EAmBM;IACE,uBAAA;EAjBR;EAoBM;IACE,WAAA;IACA,aAAA;IACA,gBAAA;EAlBR;EAoBQ;IACE,cAAA;IACA,WAAA;IACA,iBAAA;EAlBV;EAsBM;IACE,WAAA;EApBR;EAsBQ;IACE,eAAA;EApBV;EAwBU;IACE,YAAA;EAtBZ;EA0BQ;IACE,eAAA;EAxBV;AACF","sourcesContent":[".root {\n  padding-top: 40px;\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    min-height: calc(100vh - 95px);\n\n    .wrapper {\n      display: flex;\n      flex-grow: 1;\n      padding-top: 40px;\n\n      .block {\n        display: flex;\n        flex-grow: 1;\n        width: 100%;\n      }\n\n      .left {\n        width: 50%;\n\n        img {\n          display: none;\n        }\n      }\n\n      .right {\n        width: 50%;\n        padding: 40px;\n        background: #dfdfdf80;\n\n        .titleBlock {\n          font-size: 26px;\n          font-weight: bold;\n          color: #d71921;\n        }\n\n        .infoBlock {\n          color: #00377c;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding-top: 20px;\n\n    .container {\n      min-height: calc(100vh - 65px);\n\n      .wrapper {\n        padding-top: 20px;\n\n        .right {\n          padding: 20px;\n\n          .titleBlock {\n            font-size: 18px;\n          }\n\n          .imageBlock {\n            img {\n              height: 120px;\n            }\n          }\n\n          .infoBlock {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .container {\n      min-height: calc(100vh - 61px);\n\n      .wrapper {\n        flex-direction: column;\n\n        .block {\n          justify-content: center;\n        }\n\n        .left {\n          width: 100%;\n          height: 100px;\n          background: none;\n\n          img {\n            display: block;\n            width: 100%;\n            object-fit: cover;\n          }\n        }\n\n        .right {\n          width: 100%;\n\n          .titleBlock {\n            font-size: 16px;\n          }\n\n          .imageBlock {\n            img {\n              height: 80px;\n            }\n          }\n\n          .infoBlock {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OfficeDetailBlock_root__oNjx6`,
	"container": `OfficeDetailBlock_container__4WEak`,
	"wrapper": `OfficeDetailBlock_wrapper__-5Eyx`,
	"block": `OfficeDetailBlock_block__OmOH1`,
	"left": `OfficeDetailBlock_left__h33Oq`,
	"right": `OfficeDetailBlock_right__BIbpd`,
	"titleBlock": `OfficeDetailBlock_titleBlock__1ugxg`,
	"infoBlock": `OfficeDetailBlock_infoBlock__Tcpk5`,
	"imageBlock": `OfficeDetailBlock_imageBlock__9JOPx`
};
export default ___CSS_LOADER_EXPORT___;
